import ReactCookies from 'react-cookies';
import { PAGE_SIZE_CONFIG } from './config';

export const MERCHANT_INSIGHTS = (merchant) =>
  `${process.env.NEXT_PUBLIC_LEGACY_API}/merchant-dashboard-url?merchantType=${merchant}`;

const DEFAULT_SUGGGEST_API = {
  dev: `${process.env.NEXT_PUBLIC_SUGGESTER_API}/suggestwow`,
  nxt: `${process.env.NEXT_PUBLIC_SUGGESTER_API}/suggestwow`,
  prod: `${process.env.NEXT_PUBLIC_SUGGESTER_API}/suggestwow`,
};

export const DEFAULT_PUBLIC_API = 'https://public-api.5pm.co.uk';
export const DEFAULT_PUBLIC_API_TEST = 'https://public-api05.dev5pm.co.uk';

/* CURRENT URLs
Development  https://react-node05.devwowcher.co.uk/
Staging      https://react-node01.nxtwowcher.co.uk/
Production   https://react-node.wowcher.co.uk/
*/
export const URL_SHARE_POINTS = `${process.env.NEXT_PUBLIC_LEGACY_API}/reward/shareDeal`;
export const URL_VIEW_POINTS = `${process.env.NEXT_PUBLIC_LEGACY_API}/reward/viewDeal`;
export const URL_BULK_POINTS = `${process.env.NEXT_PUBLIC_LEGACY_API}/reward/bulkPublishEvents`;

export const URLSTATIC = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/staticpage`;
export const URL_GEOLOCATION = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/location`; // done and put it inside brands> fivepm > links, use it from there
export const URLNEARMEHUB = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/fenearmelocation`;
export const URL_NEARME_POPULAR_LOCATIONS = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/nearmelocation`;
export const URL_EARLY_BIRD_URL = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/early-bird-deal`;
export const URL_GIFTS_POPULAR = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/static-page/giftGuides`;
export const URL_GIFTS_SUBCATS = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/category/gifts?subCategory=null&hyperLocation=null`;
export const URL_IMG = 'https://static.wowcher.co.uk/binaries';
export const URL_NEARME_POPULAR_LOCATIONS_IMG = (area, cat) =>
  `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/nearmelocation/area/${area}/${cat}`;
export const URLNEARMELOCATION = (area) =>
  `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/category/near-me/${area}`;

// move this
export const HYPER_LOCATION_META_TITLE = (area) =>
  `${area} Deals - Restaurants, Spas, Things to do  - Wowcher`;

// move this
export const HYPER_LOCATION_META_DESCRIPTION = (area) =>
  `Check out our deals and offers for things to do in ${area}! From the best places to eat to thrilling activities for the whole family, ${area} is a great place to spend the day or even a relaxing week and with these deals you can experience the best it has to offer!`;

export const URLLOCATIONS = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/location`;
export const SUGGESTEDSEARCHURL =
  DEFAULT_SUGGGEST_API[process.env.NEXT_PUBLIC_ENVIRONMENT || 'prod'];
export const UNBOXED_SUGGESTED_SEARCH_API = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/suggest`;
export const SEARCHURL =
  ReactCookies.load('unbxd-test') === 'b'
    ? `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/unbxd/search`
    : `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/search`;
export const GUIDESEARCHURL = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/search`;
export const URLUSER = `${process.env.NEXT_PUBLIC_LEGACY_API}/user`;
export const URLDELETE = `${process.env.NEXT_PUBLIC_LEGACY_API}/user/anonymize`;
export const URLUSERSTATUS = `${process.env.NEXT_PUBLIC_LEGACY_API}/user/account-status`;
export const URLUSER_PASSWORD = `${process.env.NEXT_PUBLIC_LEGACY_API}/user/password`;
export const URLLOGIN = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/login?_spring_security_remember_me=true`;
export const URLLOGOUT = `${process.env.NEXT_PUBLIC_LEGACY_API}/logout`;
export const URLREGISTR = `${process.env.NEXT_PUBLIC_LEGACY_API}/register`;
export const URLEXPRESSREGISTR = `${process.env.NEXT_PUBLIC_LEGACY_API}/express-register`;
export const URLFBLOGIN = `${process.env.NEXT_PUBLIC_LEGACY_API}/facebook/authenticate`;
export const URLGOOGLELOGIN = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/logingoogle`;
export const URLGOOGLEREGISTR = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/registergoogleuser`;
export const URLREWARDSDETAILS = `${process.env.NEXT_PUBLIC_LEGACY_API}/reward/details`;
export const URLEXCHANGEPOINTS = `${process.env.NEXT_PUBLIC_LEGACY_API}/reward/exchange-points`;

export const URLBASKET = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/basket`;
export const URLGETBASKET = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/get/basket`;
export const URLBASKETABANDON = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/basketabandon`;
export const URLSUBSCRIBE = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/email`;
export const URLSUBSCRIBEALL = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/cauth`;
export const URLNOTIFYME = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/deal/sold-out-notification`;
export const URLEVERGREEN = `${process.env.NEXT_PUBLIC_EVERGREEN_API}/evergreen-deal-api/v1/evergreen-deals`;
export const URLNAVIGATIONS = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/navigations`;
export const URLDEAL = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/deal`;
export const URLPRODUCTDETAILPAGEDEAL = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/product-detail-page-deal`;
export const URLPRODUCTLISTINGPAGEDEAL = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/product-listing-page-deal`;
export const URLCHECKOUT = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/checkout`;
export const URLSOCIALCUE = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/socialcue/deal`;
export const URLPURCHASEVIEW = `${process.env.NEXT_PUBLIC_LEGACY_API}/deal/purchase/view`;
export const URLCHECKOUTVIEWDATA = `${process.env.NEXT_PUBLIC_LEGACY_API}/checkout/view`;
export const URLVALIDATEVOUCHER = `${process.env.NEXT_PUBLIC_LEGACY_API}/voucher`;
export const URLDEALIMPRESSION = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/deal/##LOCATION##/impressions`;
export const URLBOOKING = `${process.env.NEXT_PUBLIC_LEGACY_API}/booking`;
export const URLFLIGHTS = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/flights`;
export const URLTRAVELPRODUCTS = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/travel/products/deal`;
export const URLTILES = `${process.env.NEXT_PUBLIC_TILES_API}`;
export const URLGIFTTILES = `${process.env.NEXT_PUBLIC_TILES_API_V2}`;
export const URLSPONSOREDIMPRESSION = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/sponsored/impressionAndClick`;
export const URLWISHLIST = `${process.env.NEXT_PUBLIC_WISHLIST_API}/v1/wishlist`;
export const URLSPONSOREDCUSTOMER = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/sponsored/customer`;
export const WISHLISTSUFFIX = `?page=0&pageSize=50&detailedView=false`;
export const URLGENERATEVOUCHER = `${process.env.NEXT_PUBLIC_LEGACY_API}/deal/print-voucher`;
export const URLUPDATEVOUCHER = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/voucher`;
export const REDEEMINSTRUCTIONS = `${process.env.NEXT_PUBLIC_LEGACY_API}/deal/redeem-instructions`;
export const URLCREATERETURN = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/create-return-order`;
export const URLRETURNS = `${process.env.NEXT_PUBLIC_LEGACY_API}/v1/returns/returns-label`;
export const URLRETURNSLABEL = `${process.env.NEXT_PUBLIC_LEGACY_API}/v1/returns/pdf`;
export const URLPAYMENTINSTRUMENTS = `${process.env.NEXT_PUBLIC_LEGACY_API}/deal`;
export const URLKLARNASESSION = `${process.env.NEXT_PUBLIC_PAYMENT_URL}/kn/sessions`;
export const URLKLARNAPAYMENT = `${process.env.NEXT_PUBLIC_PAYMENT_URL}/kn/pay`;
export const URLCLEARPAYCREATECHECKOUT = `${process.env.NEXT_PUBLIC_PAYMENT_URL}/cp/checkouts`;
export const URLCLEARPAYSENDPAYMENT = `${process.env.NEXT_PUBLIC_PAYMENT_URL}/cp/pay`;
export const URLPAYBTADDON = `${process.env.NEXT_PUBLIC_PAYMENT_URL}/bt/addon`;
export const URLPAYCSADDON = `${process.env.NEXT_PUBLIC_PAYMENT_URL}/cs/addon`;
export const URLVIPUPDATE = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/update-vip-status`;

// Gifting
export const URLGIFTING = `${process.env.NEXT_PUBLIC_LEGACY_API}/gift/create`;
// -----
export const URL_GIFTING_CHECKOUT = `${
  process.env.NEXT_PUBLIC_PUBLIC_API || DEFAULT_PUBLIC_API
}/v1/checkout/config/gifting`;

// -----
export const SCROLLER_CONFIGURATION_LINK = `${
  process.env.NEXT_PUBLIC_PUBLIC_API || DEFAULT_PUBLIC_API
}/v1/content/scroller-configuration?brand=##brand##&sub-brand=5pm`;

export const URLADDON = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/order-addon`;
export const URL_PROTECT_MY_VOUCHER_REFUND_DATA = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/voucher/pmv/refund`;
export const URLCOMPLEMENTARYDEALS = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/complementary-deals`;
export const URLAMBDA = `${process.env.NEXT_PUBLIC_USER_LOOKUP}`;
// -----
export const NEW_PRODUCTS_LINK = `${
  process.env.NEXT_PUBLIC_PUBLIC_API || DEFAULT_PUBLIC_API
}/v1/product-listing-page-deal/##location##/special/new-products`;

export const URLVOUCHERFEED = (pageIndex) =>
  `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/voucher/${pageIndex}/${PAGE_SIZE_CONFIG.VOUCHER_FEED}?giftPacks=true`;
export const URL_VOUCHER_EXTENSION = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/voucher/vve`;

export const URL_PPC = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/ppc`;

// Merhant URL
export const MERCHANT_URL = {
  dev: 'https://myaccount05.devwowcher.co.uk/myaccount/merchant',
  nxt: 'https://myaccount01.nxtwowcher.co.uk/myaccount/merchant',
  prod: 'https://myaccount.wowcher.co.uk/myaccount/merchant',
};

// Kickbox lightbox
export const URLKICKBOX = (email) =>
  `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/email/verify?email=${email}`;

// Deal Preview
export const URLDEALPREVIEW = (uid) =>
  `${process.env.NEXT_PUBLIC_LEGACY_API}/preview-deal/${uid}`;

export const URL_FACETED_NAVIGATION_FOR_TRAVEL_HOMEPAGE = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/facetednavigation/wowcher/travel/gb`;

// Second checkout
export const ADDON_PAYMENT_INSTRUMENTS = `${process.env.NEXT_PUBLIC_LEGACY_API}/payment/addon/paymentInstruments`;

// Registration
export const FINDADDRESS = `${process.env.NEXT_PUBLIC_LEGACY_API}/address/postcode/##POSTCODE##`;
export const AUTOCOMPLETE = `${process.env.NEXT_PUBLIC_LEGACY_API}/address/autocomplete`;
export const VALIDATEPOSTCODE = `${process.env.NEXT_PUBLIC_LEGACY_API}/address/validate/postcode/##POSTCODE##`;
// To make it work on localhost, we can pass the apiKey
// export const SELECTADDRESS = `${process.env.NEXT_PUBLIC_LEGACY_API}/address/moniker/##MONIKER##?apiKey=cf522cfec2a4d56d569e60a152040000`;
export const SELECTADDRESS = `${process.env.NEXT_PUBLIC_LEGACY_API}/address/moniker/##MONIKER##`;
export const GET_FORMATTED_ADDRESS = `${process.env.NEXT_PUBLIC_LEGACY_API}/address/format/##GLOBALADDRESSKEY##`;

// Gift
export const URLVALIDATEGIFTCODE = `${process.env.NEXT_PUBLIC_LEGACY_API}/deal/gift-redeem`;

// GIFT CARD
export const URLREDEEMGIFTCARDCODE = `${process.env.NEXT_PUBLIC_LEGACY_API}/gift-card/redeem`;

// WALLET
export const URLWALLET = `${process.env.NEXT_PUBLIC_LEGACY_API}/user/wallet`;

// REQUEST PASSWORD RESET
export const REQUESTPASSWORDRESET = (email) =>
  `${process.env.NEXT_PUBLIC_LEGACY_API}/user/${email}/password_reset_request`;

// PASSWORD RESET
export const URLRESETPASSWORD = `${process.env.NEXT_PUBLIC_LEGACY_API}/user/password_reset`;

// PASSWORD ACTIVATE
export const URLACTIVATEPASSWORD = `${process.env.NEXT_PUBLIC_LEGACY_API}/user/password_activate`;

// User Recommendation
export const URLGETRECOMMENDATION = (userId) =>
  `${URLPRODUCTLISTINGPAGEDEAL}/recommendations/ct/${userId}?limit=40&pageSize=25&page=0`;

// User Bug again
export const URLGETBUYAGAIN = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/buy-again/deals?page=0&pageSize=10`;

// deal event service
export const URLEVENTDEAL = (location, eventName) =>
  `${URLPRODUCTLISTINGPAGEDEAL}/${location}/special/${eventName}`;

// ---- move to constants
export const EVENT_NAME_NEW_PRODUCTS = 'new-products';

// live deal service
export const URLLIVEDEAL = `${URLPRODUCTLISTINGPAGEDEAL}/live`;

// URL Track RAF SHARE
export const URLTRACKRAFSHARE = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/user/raf/stat/share`;
// URL Track RAF Open Link
export const URLTRACKOPENRAFLINK = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/user/raf/stat/open`;

// Promo Code Service
export const URLPROMOCATEGORY = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/promocode`;
export const URLPROMOSUBCATEGORY = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/promocode/subcategory`;

export const PREFERENCE_CENTRE = `${process.env.NEXT_PUBLIC_PREFERENCE_CENTRE_API}/email/preferences`;

export const AFFILIATE_EMAIL = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/affiliate-email/##AFFILIATE_NAME##`;

export const COMPLIANCE_URL = `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/compliance`;

export const LINK_FILTER_API = `${
  process.env.NEXT_PUBLIC_PUBLIC_API || DEFAULT_PUBLIC_API
}/v1/deal`;

export const LINK_NOTFOUNDHIT = `${
  process.env.NEXT_PUBLIC_PUBLIC_API || DEFAULT_PUBLIC_API_TEST
}/v1/notFoundHit`;

// end-point to add general logs to splunk
export const POST_LOGS = `${
  process.env.NEXT_PUBLIC_PUBLIC_API || DEFAULT_PUBLIC_API_TEST
}/v1/log`;

// Gift Page

// ---- move to links
export const GIFTSCANONICALURL = 'https://www.5pm.co.uk/gifts';
